import "./styles.css";

import { ShowPets } from "./ShowPets.tsx";
import { PAGE_PATHS } from "./config.ts";

export default function App() {
  return (
    <div className="flex flex-col gap-4">
      <ShowPets
        petType="cat"
        display={"carousel"}
        title={"Cats"}
        allPetsLink={PAGE_PATHS.CATS}
      />
      <ShowPets
        petType="dog"
        display={"carousel"}
        title={"Dogs"}
        allPetsLink={PAGE_PATHS.DOGS}
      />
      <ShowPets
        petType="small"
        display={"carousel"}
        title={"Critters"}
        allPetsLink={PAGE_PATHS.CRITTERS}
      />
    </div>
  );
}
